import { Stack } from '@mui/material';
import { useAtom } from 'jotai';

import ContentNotification from '@/components/ContentNotfication';
import ContactInformation from '@/features/AdminContactInformation';
import EmailConfiguration from '@/features/AdminEmailConfiguration';
import EmailSubjectTemplate from '@/features/AdminEmailSubjectTemplate';
import NewTicketEmailTemplate from '@/features/AdminNewTicketEmailTemplate';
import EscalationProfile from '@/features/EscalationProfile';
import { selectedOrganizationIdAtom } from '@/pages/Organizations';

import { useFetchSettings, useMutationSettings } from '../Administration.store';
import type { SettingsTypes } from '../Administration.types';
import { useFetchOrgUsers } from '../Users/Users.hooks';

const AdministrationNotifications = () => {
  const { refetch, data: orgInfo } = useFetchSettings();
  const mutation = useMutationSettings(refetch);
  const [selectedOrganizationId] = useAtom(selectedOrganizationIdAtom);
  const { data: orgUsers, isLoading: isLoadingUsers } = useFetchOrgUsers(true);

  const handleSave = (updatedContactInfo: SettingsTypes) => {
    mutation.mutate(updatedContactInfo);
  };

  return (
    <Stack spacing={2}>
      {selectedOrganizationId === 0 && (
        <ContentNotification
          title="Select an organization"
          text="Please select an organization to view and edit its contact information."
        />
      )}
      {selectedOrganizationId !== 0 && (
        <>
          <ContactInformation orgInfo={orgInfo} handleSave={handleSave} />
          <EscalationProfile
            orgInfo={orgInfo}
            handleSave={handleSave}
            orgUsers={orgUsers}
            isLoadingUsers={isLoadingUsers}
          />
          <EmailConfiguration orgInfo={orgInfo} handleSave={handleSave} />
          <EmailSubjectTemplate orgInfo={orgInfo} handleSave={handleSave} />
          <NewTicketEmailTemplate orgInfo={orgInfo} handleSave={handleSave} />
        </>
      )}
    </Stack>
  );
};

export default AdministrationNotifications;
